import { Switch, Tooltip } from 'antd'
import PropTypes from 'prop-types'
import { useFeatureEnabled } from '../../redux/slices/session'

function AuthorizedSwitch({ record, handleAuthorizedChange }) {
  const disableAuthorizedColumn = useFeatureEnabled('disable_authorized_column')

  const switchElement = <Switch
    checked={record.authorized}
    disabled={record.active === false || disableAuthorizedColumn}
    checkedChildren="Authorized"
    unCheckedChildren="Not&nbsp;Authorized"
    onChange={authorized => {
      if (!disableAuthorizedColumn) {
        handleAuthorizedChange(record.id, authorized)
      }
    }}
  />
  return disableAuthorizedColumn
    ? <Tooltip title="Pre Authorizations are being handled by BioBridge. This function is disabled.">
        {switchElement}
      </Tooltip>
    : switchElement
}

AuthorizedSwitch.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.string.isRequired,
    authorized: PropTypes.bool.isRequired,
    active: PropTypes.bool.isRequired,
  }).isRequired,
  handleAuthorizedChange: PropTypes.func.isRequired,
}

export default AuthorizedSwitch
